import { Container } from '@chakra-ui/react'
import { SelectedOrgChecker } from '@features/organisations/components/SelectedOrgChecker'
import { createFileRoute } from '@tanstack/react-router'
import { ListProjects } from '@features/projects/components/ListProjects'
import { zodValidator } from '@tanstack/zod-adapter'
import {
  listProjectRequestSchema,
  PROJECT_ORDER_BY_FIELDS,
} from '@customTypes/cloudmix/projects'
import { DEFAULT_ORDER } from '@customTypes/cloudmix/api'
import { withListHydration } from '@lib/listState/withListHydration'

const ListProjectsRoute = () => (
  <Container maxW={'75rem'}>
    <SelectedOrgChecker>
      <ListProjects />
    </SelectedOrgChecker>
  </Container>
)

const routerSchema = listProjectRequestSchema.partial().catch({})
export const Route = createFileRoute('/_auth/o/$orgId/projects/')({
  component: ListProjectsRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {
      defaultSort: [DEFAULT_ORDER],
      allowedOrderByFields: PROJECT_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Projects',
  }),
})
